import React, { createContext, useContext, useEffect, useState } from 'react';
import Api from 'utils/api';

// Crear un contexto para el WebSocket
const WebSocketContext = createContext();

// Crear un componente proveedor que gestione la conexión del WebSocket
export const WebSocketProvider = ({ url, children }) => {
  const [sockets, setSockets] = useState([]);

  useEffect(() => {

    Api.servers.forEach(async (item) => {
      const newSocket = new WebSocket('ws://' + item.url + '/updates?key=asd');

      newSocket.addEventListener('open', (event) => {
        console.log('Conexión establecida: ' + item.name, event);

        // Puedes realizar acciones adicionales después de la conexión
      });

      const newObj = {
        socket: newSocket,
        listenerReady: false,
        id: item.id
      }
      setSockets((prev) => [...prev, newObj]);
    });


    return () => {
      sockets.map(item => item.close())
    };

  }, []);

  return (
    <WebSocketContext.Provider value={sockets}>
      {children}
    </WebSocketContext.Provider>
  );
};

// Crear un hook personalizado para acceder al objeto WebSocket
export const useWebSocket = () => {
  const sockets = useContext(WebSocketContext);

  if (!sockets) {
    //throw new Error('useWebSocket debe ser utilizado dentro de un WebSocketProvider');
  }

  return sockets;
};